// src/store/index.js
import { createStore } from 'vuex'
import api from '@/services/api'
import { withPortraitTraits } from '@/services/portrait-traits.mjs'

export default createStore({
  state: {
    nakaIds: {},
    owners: {},
    dispensers: [],
    PFPInfos: {},
    osListings: {},
    currency: 'BTC'
  },
  mutations: {
    SET_NAKA_IDS(state, nakaIds) {
      state.nakaIds = nakaIds
    },
    SET_OWNERS(state, owners) {
      state.owners = owners
    },
    SET_DISPENSERS(state, dispensers) {
      state.dispensers = dispensers
    },
    SET_PFP_INFOS(state, PFPInfos) {
      state.PFPInfos = withPortraitTraits(PFPInfos)
    },
    SET_OS_LISTINGS(state, osListings) {
      state.osListings = osListings
    },
    SET_CURRENCY(state, currency) {
      state.currency = currency
    }
  },
  actions: {
    async fetchNakaHistory({ commit }) {
      const response = await api.getNakaHistory()
      commit('SET_NAKA_IDS', response.data.ids)
      commit('SET_OWNERS', response.data.owners)
      commit('SET_DISPENSERS', response.data.dispensers)
    },
    async fetchPFPInfos({ commit }) {
      const response = await api.getPFPInfos()
      commit('SET_PFP_INFOS', response.data)
    },
    async fetchOpenSeaInfo({ commit }) {
      const response = await api.getOpenSeaInfo()
      commit('SET_OS_LISTINGS', response.data.listings)
    },
    setCurrency({ commit }, currency) {
      commit('SET_CURRENCY', currency)
    }
  },
  getters: {
    getNakaById: (state) => (id) => {
      return state.nakaIds[`#${id}`]
    },
    getPFPInfoById: (state) => (id) => {
      return state.PFPInfos[`#${id}`]
    },
    getCurrentCurrency: (state) => {
      return state.currency
    }
  }
})
